import { Box } from '@mui/material'
import { ReactElement } from 'react'
import TruncatedText from './TruncatedText'

export type IValueType = 'STRING' | 'LINK' | 'COMPONENT'
type IValue = string | number | ReactElement | null

export interface IKeyValue {
    name: string
    value: IValue
    type?: IValueType
    keyWidth?: string // optional, if not provided, the default width will be used 50%
}

const KeyValue = (props: IKeyValue): ReactElement => {
    const { name, value, type, keyWidth } = props
    const renderValue = (value: IValue) => {
        switch (type) {
            case 'COMPONENT':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {value}
                    </Box>
                )
            case 'LINK':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {value}
                    </Box>
                )
            default: // 'STRING' or any other cases
                return (
                    <TruncatedText
                        sx={{ fontSize: '14px' }}
                        text={value as string}
                    />
                )
        }
    }

    return (
        <Box
            style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
            }}
            key={name}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: keyWidth || '50%',
                }}
            >
                <TruncatedText
                    sx={{
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                    text={name}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <span
                    style={{
                        marginLeft: '10px',
                        marginRight: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                    }}
                >
                    :
                </span>
                {renderValue(value)}
            </Box>
        </Box>
    )
}

export default KeyValue
